import React from "react";
import Scrollchor from "react-scrollchor";

export default () => (
  <section id="two" className="spotlight style2 right">
    <span className="image fit main">
      <img src="images/pic03.jpg" alt="" />
    </span>
    <div className="content">
      <header>
        <h2 className={'text-center'}>Languages I speak</h2>
      </header>

      <div className={'technologies'} >
        <section>
          <ul className={"tools"}>
            <h5 >Development Technologies</h5>
            <li>VsCode </li>
            <li>GitHub </li>
            <li>Css Frameworks </li>
            <li>Linux</li>
            <li>GitLab</li>
            <li>Aws</li>
            <li>Firebase</li>
            <li>docker</li>
            <li>Ruby on Rails</li>
            <li>React</li>
            <li>React Native</li>
            <li>Node.js</li>
            <li>Django</li>
          </ul>
        </section>

        <section>
          <ul className={"tools"}>
            <h5>Languages</h5>
            <li>Ruby</li>
            <li>Python</li>
            <li>Javascript</li>
            <li>Typescript</li>
            <li>CSS3</li>
            <li>Sass</li>
          </ul>
        </section>
      </div>
    </div>
    <Scrollchor
        to={"#three"}
        className={"goto-next"}
        animate={{offset: 20, duration: 600}}
    >
      Next
    </Scrollchor>
  </section>
);
